import type { Theme } from './themes.js';
import { dark, light } from './themes.js';

/**
 * The white-label surface.
 *
 * Nothing here is implemented as a partner build yet — there is exactly one
 * brand (`defaultBrand`). The point of declaring the type now is that when a
 * partner deal lands, branding is a config object rather than a fork.
 *
 * Rank *names* live here rather than in @aj/core deliberately: a partner may
 * want "Udvash Scholar" without any change to progression maths.
 */
export type BrandConfig = {
  id: string;
  appName: string;
  /**
   * Wordmark paths, resolved by the host app.
   *
   * Two files rather than one because the mark is flat ink on a transparent
   * ground, and an `<img>` cannot inherit `currentColor` the way an inlined
   * `<svg>` can. A single asset would be legible in one theme and invisible in
   * the other.
   */
  logo: { onLight: string; onDark: string };
  /** Mascot sprite set id — swapped wholesale for a partner build. */
  mascotSet: string;
  themes: { light: Theme; dark: Theme };
  /** Override display names per rank id; falls back to the default strings. */
  rankNames?: Record<string, { en: string; bn: string }>;
  /** Restrict or extend the Goal presets a partner's students see. */
  goalPresets?: string[];
  /** Share card template id. */
  shareCardTemplate: string;
};

export const defaultBrand: BrandConfig = {
  id: 'agrojatra',
  appName: 'Agrojatra',
  logo: { onLight: '/brand/agrojatra-on-light.svg', onDark: '/brand/agrojatra-on-dark.svg' },
  mascotSet: 'default',
  themes: { light, dark },
  shareCardTemplate: 'default',
};
